import { ClientService } from "../api/psc";

export function checkVersionAndUpdateIfNeeded() {
    ClientService.getVersion("1").then((r) => {
        const currentVersion = parseInt(localStorage.getItem("v") ?? "");
        if (isNaN(currentVersion)) {
            localStorage.setItem("v", r.toString());
        } else {
            if (r > currentVersion) {
                localStorage.setItem("v", r.toString());
                // eslint-disable-next-line no-restricted-globals
                location.reload();
            }
        }
    });
}
